var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup28(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 428.178,
    height: 257,
    viewBox: "0 0 428.178 257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#26093a;}.b{fill:#ccc;}.c{fill:#ffb8b8;}.d{fill:#2f2e41;}.e{fill:#464353;}.f{fill:#fff;}.g{fill:#5c188c;}.h{fill:#e6e6e6;}.i{fill:#3f3d56;}.j{fill:#cc18a2;}.k{fill:#7c20bf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M245.406,274.869a26.934,26.934,0,1,1,26.934-26.934,26.934,26.934,0,0,1-26.934,26.934Zm0-52.747a25.812,25.812,0,1,0,25.812,25.812,25.812,25.812,0,0,0-25.812-25.812Z",
    transform: "translate(-218.472 -221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M581.939,267.935a13.467,13.467,0,1,1,13.467-13.467A13.467,13.467,0,0,1,581.939,267.935Zm0-25.812a12.345,12.345,0,1,0,12.345,12.345A12.345,12.345,0,0,0,581.939,242.122Z",
    transform: "translate(-372.074 -229.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M749.623,382.3a15.151,15.151,0,1,1,15.151-15.151A15.151,15.151,0,0,1,749.623,382.3Zm0-29.179a14.028,14.028,0,1,0,14.028,14.028A14.028,14.028,0,0,0,749.623,353.122Z",
    transform: "translate(-444.926 -278.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M881.345,678.122H755.089a.561.561,0,1,1,0-1.122H881.345a.561.561,0,0,1,0,1.122Z",
    transform: "translate(-453.728 -421.122)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 13.782,
    cy: 13.782,
    r: 13.782,
    transform: "translate(345.859 58.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M629.272,400.692l-6.514,2.212-11.634-24.072,9.614-3.265Z",
    transform: "translate(-268.2 -164.823)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.353,0H21.62V8.354H0A8.354,8.354,0,0,1,8.353,0Z",
    transform: "translate(341.362 240.487) rotate(-18.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M660.721,423.848l-6.87.345-4.6-26.337,10.141-.51Z",
    transform: "translate(-284.932 -174.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.354,0H21.621V8.354H0A8.354,8.354,0,0,1,8.354,0Z",
    transform: "translate(355.568 248.517) rotate(-2.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M807.891,488.044a5.643,5.643,0,0,0-.263-8.648l6.551-18.952-10.1,2.58-4.672,17.6a5.673,5.673,0,0,0,8.48,7.419Z",
    transform: "translate(-472.989 -326.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M856.3,582.834a2.549,2.549,0,0,1-.266-.014l-9.326-.988a2.51,2.51,0,0,1-2.243-2.23l-7.207-64.256-5.216,17.583,9.724,34.557a2.525,2.525,0,0,1-2.142,3.193l-9.454,1.087a2.538,2.538,0,0,1-2.729-1.86l-10.33-38.888a2.513,2.513,0,0,1-.062-.981l4.643-34.9,34.63,2.777,2.5,82.32a2.525,2.525,0,0,1-2.524,2.6Z",
    transform: "translate(-481.157 -341.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M845.539,454.41c-11.6,0-24.737-4.483-25.533-4.758l-.23-.08,13.089-67.159.241.01c5.187.21,19.342.318,19.484.32l.254,0,5.456,59.267.975,8.669-.119.1C855.818,453.475,850.838,454.41,845.539,454.41Z",
    transform: "translate(-482.362 -291.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M821.933,448.262l-8.186-3.3,4.172-50.471a8.337,8.337,0,0,1,3.633-6.231l4.308-2.932h0a2.732,2.732,0,0,1,2.709-3.5l1.234.04a1.4,1.4,0,0,1,2.148,1.493l-.271,5.347Z",
    transform: "translate(-479.717 -291.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M812.614,446.465l-10.689-.45,3.463-22.273,2.869-20.958a5.008,5.008,0,0,1,6.5-4.4h0a5,5,0,0,1,3.465,5.413L815.312,426.5Z",
    transform: "translate(-474.529 -298.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M849.927,448.516l-.073-.225c-.05-.154-4.867-15.606,3.194-34.045l4.042-20.1,3.454-12.623a1.509,1.509,0,0,1,.915-.995,1.39,1.39,0,0,1,1.486.382h0a9.65,9.65,0,0,1,7.216.722l4.851,2.555a5.507,5.507,0,0,1,2.8,6.129l-6.63,28.294,3.223,26.428Z",
    transform: "translate(-494.917 -290.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M859.729,467a5.643,5.643,0,0,0,6.239-6l15.014-11.122-5.248-2.488-16.19,8.34A5.673,5.673,0,0,0,859.729,467Z",
    transform: "translate(-497.66 -320.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M876.525,435.939l-5.071-9.466,12.506-8.231-6.1-21.89a6.619,6.619,0,0,1,5.067-8.266h0a6.636,6.636,0,0,1,7.575,4.357l8.235,24.2a2.525,2.525,0,0,1-.848,2.813Z",
    transform: "translate(-505.042 -294.272)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.854,337.177c-1.652.215-2.9-1.475-3.476-3.038s-1.018-3.382-2.455-4.226c-1.962-1.153-4.473.234-6.717-.147-2.534-.43-4.182-3.116-4.311-5.683s.892-5.036,1.895-7.4l.35,2.942a5.833,5.833,0,0,1,2.549-5.1l-.451,4.316a4.581,4.581,0,0,1,5.27-3.791l-.071,2.572a42.48,42.48,0,0,1,8.816-.431,14.258,14.258,0,0,1,8.117,3.128c3.328,2.892,4.544,7.654,4.136,12.045s-2.221,8.515-4.109,12.5c-.475,1-1.133,2.134-2.235,2.261a2.251,2.251,0,0,1-2.2-1.661,6.019,6.019,0,0,1,.027-2.958,12.576,12.576,0,0,0,.368-4.475,3.648,3.648,0,0,0-2.823-3.13c-1.495-.182-3.025,1.527-2.306,2.85Z",
    transform: "translate(-487.237 -262.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M487.01,601.776l-5.365-2.259-3.68-26.894H428.955l-3.989,26.784-4.8,2.4a1.14,1.14,0,0,0,.51,2.159h65.892a1.14,1.14,0,0,0,.442-2.19Z",
    transform: "translate(-306.712 -375.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M502.979,548.718H262.231a4.77,4.77,0,0,1-4.759-4.77V510H507.738v33.949a4.77,4.77,0,0,1-4.759,4.77Z",
    transform: "translate(-235.587 -347.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M507.818,420.49H257.08V275.23a5.756,5.756,0,0,1,5.75-5.75H502.068a5.756,5.756,0,0,1,5.75,5.75Z",
    transform: "translate(-235.415 -242.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M501.088,418.192H280.3a4.438,4.438,0,0,1-4.433-4.433V292.7a4.438,4.438,0,0,1,4.433-4.433H501.088a4.438,4.438,0,0,1,4.433,4.433V413.759a4.438,4.438,0,0,1-4.433,4.433Z",
    transform: "translate(-243.661 -250.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M505.882,628.1H292.089a.561.561,0,0,1,0-1.122H505.882a.561.561,0,0,1,0,1.122Z",
    transform: "translate(-250.533 -399.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M499.6,424.909h-179.3a.561.561,0,0,1-.561-.561v-85.94a.561.561,0,0,1,1.122,0v85.378H499.6a.561.561,0,0,1,0,1.122Z",
    transform: "translate(-262.911 -272.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M374.945,461.812H358.637a1.668,1.668,0,0,1-1.666-1.666V437.665A1.668,1.668,0,0,1,358.637,436h16.308a1.668,1.668,0,0,1,1.666,1.666v22.481A1.668,1.668,0,0,1,374.945,461.812Z",
    transform: "translate(-279.254 -315.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M427.946,445.135H411.637a1.668,1.668,0,0,1-1.666-1.666v-43.8A1.668,1.668,0,0,1,411.637,398h16.308a1.668,1.668,0,0,1,1.666,1.666v43.8A1.668,1.668,0,0,1,427.946,445.135Z",
    transform: "translate(-302.514 -298.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M480.946,461.812H464.637a1.668,1.668,0,0,1-1.666-1.666V437.665A1.668,1.668,0,0,1,464.637,436h16.308a1.668,1.668,0,0,1,1.666,1.666v22.481A1.668,1.668,0,0,1,480.946,461.812Z",
    transform: "translate(-325.774 -315.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M533.946,438.552H517.637a1.631,1.631,0,0,1-1.666-1.59V384.59a1.631,1.631,0,0,1,1.666-1.59h16.308a1.631,1.631,0,0,1,1.666,1.59v52.372a1.631,1.631,0,0,1-1.666,1.59Z",
    transform: "translate(-349.034 -292.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M586.945,426.7H570.637a1.668,1.668,0,0,1-1.666-1.666V357.665A1.668,1.668,0,0,1,570.637,356h16.308a1.668,1.668,0,0,1,1.666,1.666v67.372a1.667,1.667,0,0,1-1.666,1.665Z",
    transform: "translate(-372.293 -280.247)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3.367,
    cy: 3.367,
    r: 3.367,
    transform: "translate(84.171 107.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3.367,
    cy: 3.367,
    r: 3.367,
    transform: "translate(113.911 85.293)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3.367,
    cy: 3.367,
    r: 3.367,
    transform: "translate(143.651 107.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3.367,
    cy: 3.367,
    r: 3.367,
    transform: "translate(173.391 74.631)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3.367,
    cy: 3.367,
    r: 3.367,
    transform: "translate(203.131 62.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M215.288,162.521l-29.811-22.329-29.4,22.023-.673-.9,30.077-22.528,29.669,22.223,29.483-32.264.118-.048,29.74-11.982.42,1.041-29.622,11.935Z",
    transform: "translate(-68.199 -51.223)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup28);
export default __webpack_public_path__ + "static/media/Group 28.f1f2c852fec90225842a4825cd837f11.svg";
export { ForwardRef as ReactComponent };